module.exports = __webpack_public_path__ + "static/img/lap03.5cce7bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/lap03.png
// module id = IgpK
// module chunks = 11